<template>
  <Dialog ref="dialog" type="confirm" :show="$bus.confirmDialog.show">
    <template v-slot:dialog-content>
      <p class="confirm-tip bebas-font" v-html="getText"></p>
      <div class="confirm-notice" @click="handleClick">
        <span class="notice-checkbox">
          <i class="checkbox-right" v-show="!notice"/>
        </span>
        <span class="notice-text bebas-font">{{$bus.transify['POPUP_NO_REMIND']}}</span>
      </div>
      <ff-button type="confirm" @btnEvent="handleConfirm">
        <span class="confirm-btn-text bebas-font">{{$bus.transify['COMMON_CONFIRM']}}</span>
      </ff-button>
    </template>
  </Dialog>
</template>

<script>
import ffButton from '@/components/common/Button.vue'
import Dialog from '@/components/common/Dialog.vue'
export default {
  components: {
    ffButton,
    Dialog
  },
  data () {
    return {
      notice: true
    }
  },
  computed: {
    getText () {
      const type = this.$bus.confirmDialog.type || ''
      switch (type) {
        case 'refresh':
          this.initNotice(this.$bus.refreshNotice)
          return this.replaceText(this.$bus.transify['LUCKY_REFRESH_DEBACK'],
                  '{cost}',
                  `<span style="font-size: 1.3em; color: #FFDE00; font-weight: 500;">${this.$bus.refreshCost}</span>`)
        default:
          return ''
      }
    }
  },
  methods: {
    handleClick () {
      this.$bus.clickSound = true
      this.notice = !this.notice
    },
    replaceText (text, source, target) {
      if (text && text.indexOf(source) > -1) {
        return text.replace(source, `${target}`)
      } else {
        return text
      }
    },
    handleConfirm () {
      const type = this.$bus.confirmDialog.type
      switch (type) {
        case 'refresh':
          const refreshCost = this.$bus.refreshCost
          if (!this.notice) {
            this.$bus.refreshNotice = this.notice
            localStorage.setItem(`${PROJECT_NAME}_${type}_${this.$bus.uid}`, this.$bus.refreshNotice)
          }
          this.$bus.refresh(refreshCost)
          break
      }
      this.$bus.clickSound = true
      this.notice = true
      this.$bus.confirmDialog.show = false
      this.$bus.addGA(`${type}_close_notice`, 'true')
    },
    initNotice (bool) {
      this.notice = bool
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm-btn-text {
  flex: auto;
  color: #422411;
  text-shadow:1px 0px 0px rgba(0, 0, 0, .1);
  background: linear-gradient(0deg,rgba(33,16,0,1) 0%, rgba(107,43,0,1) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  @include px2res(height, 62);
  @include px2res(line-height, 66);
}
.confirm-tip {
  max-width: 74%;
  margin: 0 auto;
  text-align: center;
  line-height: 1;
  @include px2res(font-size, 46);
}
.confirm-notice {
  @include flexrc;
  @include px2res(margin, 40, auto, 57);
  .notice-checkbox {
    position: relative;
    @include px2res(width, 22);
    @include px2res(height, 22);
    @include px2res(margin-right, 12);
    background-color: #000;
    background-size: 98% auto;
    .checkbox-right {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @include px2res(width, 12);
      @include px2res(height, 12);
      background-size: 98% auto;
    }
  }
  .notice-text {
    @include px2res(font-size, 24);
    @include px2res(height, 22);
    @include px2res(line-height, 26);
    white-space: nowrap;
    text-transform: uppercase;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/confirm/index.vue